import {classNames, MessageView, PushButton} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";

interface AddDeliveryToBoxViewProps {
	onHandleAddDeliveryToBox: () => void;
	onSeparateBox: () => void;
}
export function AddDeliveryToBoxView({onHandleAddDeliveryToBox, onSeparateBox}: AddDeliveryToBoxViewProps) {
	const {t} = useLocalization();

	return (
		<MessageView message={t("AddDeliveryToBoxMessage")} messageClassName={styles.messageView}>
			<PushButton onClick={onHandleAddDeliveryToBox} className={classNames(styles.action)}>
				{t("AddDeliveryToBox")}
			</PushButton>
			<PushButton onClick={onSeparateBox} className={classNames(styles.action)}>
				{t("UseSeparateBox")}
			</PushButton>
		</MessageView>
	);
}

const styles = stylesheet({
	messageView: {
		maxWidth: "36em",
	},
	action: {
		margin: "2em",
		cursor: "pointer",
	},
});
